import React, { useMemo, useState } from 'react';
import { Button, FormGroup, Icon, Intent, MenuItem, Spinner } from '@blueprintjs/core';
import { ItemRenderer, Select2 } from '@blueprintjs/select';
import { IconNames } from '@blueprintjs/icons';
import debounce from 'lodash/debounce';

type Callback = (value?: any) => void;

interface ISelectAsyncProps {
  selected: any;
  loading: boolean;
  results: null | any;
  onSearch: Callback;
  onSelect: Callback;
  label?: string;
}

interface IItem {
  // label?: string;
  // value?: string;
  name: string;
  uid: string;
  [key: string]: string;
}

const ItemSelect = Select2.ofType<IItem>();

const renderItem: ItemRenderer<IItem> = (item: IItem, { handleClick, modifiers }: any) => {
  const isActive = modifiers.active;
  /*
   * If an MenuItem has icon specified and is active, show Intent.PRIMARY, else mark it with IconNames.TICK
   */
  return (
    <MenuItem
      icon={IconNames.DOCUMENT}
      intent={isActive ? Intent.PRIMARY : undefined}
      text={item.name}
      key={item.uid}
      onClick={handleClick} />
  );
};

export const SelectAsyncComponent = ({
  selected,
  loading,
  results,
  onSearch,
  onSelect,
  label,
}: ISelectAsyncProps) => {
  const debounceOnSearch = useMemo(() => debounce(onSearch, 800), [ onSearch ]);

  const leftElement = (
    loading ? (
      <span className="bp4-icon">
        <Spinner size={16} />
      </span>
    ) : <Icon icon={IconNames.SEARCH} />
  );

  return (
    <FormGroup label={label}>
      <ItemSelect
        className="select-async"
        activeItem={null}
        filterable={true}
        items={results || []}
        itemRenderer={renderItem}
        onItemSelect={onSelect}
        popoverProps={{
          captureDismiss: true, /* close only this popover */
          usePortal: true,
          minimal: true
        }}
        inputProps={{
          leftElement
        }}
        onQueryChange={debounceOnSearch}
      >
        <Button
          className="select-async__button"
          text={selected ? selected.name : 'Search'}
          minimal={false}
          fill={true}
          icon={IconNames.DOCUMENT}
          rightIcon={IconNames.CARET_DOWN} />
      </ItemSelect>
    </FormGroup>
  );
};

export const SelectAsync = React.memo(SelectAsyncComponent);
